import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const tratoService = {
  syncTratoFromPipeDrive,
  getAll,
  getAllFilter,
  guardarTrato,
}

async function syncTratoFromPipeDrive() {
  return await ApiBudgety.get('Trato/SyncTratoFromPipeDrive/')
}

async function getAll() {
  return await ApiBudgety.get('Trato/GetAll/')
}

async function getAllFilter(body) {
  return await ApiBudgety.post('Trato/getAllFilter/', body)
}

async function guardarTrato(trato) {
  return await ApiBudgety.post('Trato/InsertOrUpdate/', trato, {
    headers: {
      ACCION: MenusSistema.proyecto_trato.accesos.modificar_trato,
      MENU: MenusSistema.proyecto_trato.id,
    },
  })
}
